import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-perfiles-ocupacionales',
  templateUrl: './main-perfiles-ocupacionales.component.html',
  styleUrls: ['./main-perfiles-ocupacionales.component.css']
})
export class MainPerfilesOcupacionalesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
